/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2CalendarDate/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2CalendarDate({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2CalendarDate",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#000"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2CalendarDate.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 14"
 style={{'--as-1-ZLBSlP': alignSelf,'--mt-2-ZLBSlP': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZLBSlP': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZLBSlP': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZLBSlP': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZLBSlP': opacity,'--w-10-ZLBSlP': typeof width === 'number' ? `${width}px` : width,'--h-11-ZLBSlP': typeof height === 'number' ? `${height}px` : height,'--f-12-ZLBSlP': fill,'--a-7-ZLBSlP': isAnimated ? animation : "none",'--sd-8-ZLBSlP': isAnimated ? strokeDashoffset : 0,'--sd-9-ZLBSlP': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2CalendarDate.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M4.5 1a1 1 0 00-2 0v1h-1A1.5 1.5 0 000 3.5v9A1.5 1.5 0 001.5 14h11a1.5 1.5 0 001.5-1.5v-9A1.5 1.5 0 0012.5 2h-1V1a1 1 0 10-2 0v1h-5V1zM3 7a1 1 0 100-2 1 1 0 000 2zm5-1a1 1 0 11-2 0 1 1 0 012 0zm-5 5a1 1 0 100-2 1 1 0 000 2zm5-1a1 1 0 11-2 0 1 1 0 012 0zm3-3a1 1 0 100-2 1 1 0 000 2z"
 style={{'--f-12-ZLBSlP': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}